/**
  * Die JS-Schnittstelle zwischen WBT-Reviewer und WBT-Player
  * @namespace v3sWbtPlayerApp:annotation
  */

/**
 * Definiert die Schnittstelle für die Kommunikation mit dem WBT-Reviewer. <br>
 * Die Messages können über die Metode frame.postMessage(message, targetOrigin) gesendet werden. <br>
 * Mit window.addEventListener("message", receiveMessageFunction, false) können die Messages empfangen werden.
 * @class service_v3sAnnotationService
 * @memberOf v3sWbtPlayerApp:annotation
 */
angular.module('v3sWbtPlayerApp').factory('v3sAnnotationService', ["$rootScope", "$window", "$state", "v3sLexikonService", "v3sLog", "v3sSelectionService", "v3sWbtDataService", function ($rootScope, $window, $state, v3sLexikonService, v3sLog, v3sSelectionService, v3sWbtDataService) {

    var annotationApp = null;
    var annotationAllowed = true;
    var wbt = null;
    var test = null;
    $window.addEventListener("message", receiveMessage, false);

    /**
    * Schickt die Nachricht an den WBT-Reviewer
    * @memberOf v3sWbtPlayerApp:annotation.service_v3sAnnotationService
    * @param {string} ressource - Ressource [location, wbtPages, pageElements, selectionMode, selection]
    * @param {Object} result - Ergebnis der Anfrage
    * @param {string} error - Fehlerbeschreibung
    */
    function postResult(ressource, result, error) {
        if (!!annotationApp) {
            result = !!result ? result : null;
            error = !!error ? error : null;
            var msg = angular.toJson({ ressource: ressource, result: result, error: error }, false);
            annotationApp.postMessage(msg, "*");
            // v3sLog.log(msg);
        }
    }

    /**
    * Empfängt die Nachricht von dem WBT-Reviewer
    * @memberOf v3sWbtPlayerApp:annotation.service_v3sAnnotationService
    * @param {Object} event - Nachricht
    */
    function receiveMessage(event) {
        if (annotationAllowed) {
            try {
                if (!!event.source && !!event.data) {
                    var data = angular.fromJson(event.data);
                    if (!!data && !!data.ressource && !data.result && !data.error) {
                        if (!annotationApp && data.ressource === "init") {
                            init(event.source);
                        } else if (!!annotationApp && annotationApp === event.source) {
                            switch (data.ressource) {
                                case "location":
                                    location(data.params);
                                    break;
                                case "wbtPages":
                                    wbtPages();
                                    break;
                                case "pageElements":
                                    pageElements();
                                    break;
                                case "entries":
                                    entries(data.params);
                                case "selectionMode":
                                    selectionMode(data.params);
                                    break;
                                case "selection":
                                    selection(data.params);
                                    break;
                                default:
                                    postResult(data.ressource, null, "Error: Unknown ressource.");
                            }
                        }
                    }
                }
            } catch (e) {
                v3sLog.warn("Exception: ", false, e);
            }
        }
    }

    /**
    * Initialisiert die Schnittstelle
    * @memberOf v3sWbtPlayerApp:annotation.service_v3sAnnotationService
    * @param {Object} newAnnotationApp - Objekt, über welches die Nachrichten gesendet und empfangen werden
    */
    function init(newAnnotationApp) {
        v3sWbtDataService.load().then(function () {
            wbt = v3sWbtDataService.getWbt();
            var testSco = wbt.getTestSco();
            if (!!testSco) {
                test = testSco.getTest();
            }

            if (!annotationApp) {
                annotationApp = newAnnotationApp;

                postResult("init", { inited: true });
            } else {
                postResult("init", { inited: false }, "Error: Only one initialization is allowed.");
            }
        });
    }

    /**
    * ...
    * @memberOf v3sWbtPlayerApp:annotation.service_v3sAnnotationService
    * @param {Object} params - ...
    */
    function location(params) {
        if (!!params && !!params.location && !!params.location.scoId) {
            $state.go("main.sco", {scoId: params.location.scoId, entry: params.location.pageId });
        } else {
            var location = {};
            if(!!$state.params.scoId){
                location.scoId = $state.params.scoId;
                if (!!$state.params.entry) {
                    location.pageId = $state.params.entry;
                }
            }
            postResult("location", { location: location });
        }
    }

    /**
    * ...
    * @memberOf v3sWbtPlayerApp:annotation.service_v3sAnnotationService
    */
    function pageElements() {
        var elements;
        elements = v3sSelectionService.getSelectableElements();
        postResult("pageElements", { elements: elements });
    }

    /**
    * Liefert eine Liste von Einträgen, je nach Parameter. Für Lexikon: param.type="lexikon".
    * @memberOf v3sWbtPlayerApp:annotation.service_v3sAnnotationService
    */
    function entries(params) {
        if (params.type === "lexikon") {
            v3sLexikonService.getLexikon().then(function (lexikon) {
                var entries = [], path, entry;

                for (path in lexikon) {
                    entry = lexikon[path];

                    if (path.lastIndexOf(".xml") === path.length - 4) {
                        path = path.substring(0, path.length - 4);
                    }

                    entries.push({
                        title: entry.title,
                        id: path
                    });
                }

                postResult("entries", { entries: entries, type: "lexikon" });
            });
        } else {
            v3sLog.log("Unsupported entry type: " + params.type);
        }
    }

    /**
    * ...
    * @memberOf v3sWbtPlayerApp:annotation.service_v3sAnnotationService
    */
    function wbtPages() {
        var pages = [];

        var items = wbt.children;
        addPages(pages, items);

        postResult("wbtPages", { pages: pages });
    }

    /**
    * ...
    * @memberOf v3sWbtPlayerApp:annotation.service_v3sAnnotationService
    * @param {Array} pageList - ...
    * @param {Array} items - ...
    * @param {bool} flatList - wenn true, wird keine Unterstruktur erzeugt
    */
    function addPages(pageList, items, flatList) {
        for (var index in items) {
            var item = items[index];
            var childItem = { title: item.title, id: item.id };
            pageList.push(childItem);

            if (!!item.children && item.children.length > 0 && item.children[0].id != item.id) {
                childItem.children = [];

                addPages(flatList ? pageList : childItem.children, item.children, flatList || item.testSco);
            }
        }
    }

    /**
    * ...
    * @memberOf v3sWbtPlayerApp:annotation.service_v3sAnnotationService
    * @param {Object} params - ...
    */
    function selectionMode(params) {
        if (params){
            if (typeof params.mode === 'boolean') {
                v3sSelectionService.setActive(params.mode);
            }

            if (!!test) {
                test.setReview(!!params.showAll);
            }
        }
        postResult("selectionMode", { mode: v3sSelectionService.getActive(), showAll: !!params.showAll });
    }

    /**
    * ...
    * @memberOf v3sWbtPlayerApp:annotation.service_v3sAnnotationService
    * @param {Object} params - ...
    */
    function selection(params) {
        if (!!params && !!params.selection) {
            if (params.type == "lexikon") {
                params.selection = "LEX" + params.selection;
            }
            v3sSelectionService.setSelection(params.selection, params.type);
        } else {
            var selectedElement = v3sSelectionService.getSelection();
            postResult("selection", { selection: selectedElement });
        }
    }

    /**
    * ...
    * @function onSelectionChanged
    * @memberOf v3sWbtPlayerApp:annotation.service_v3sAnnotationService
    * @param {string} selection - ...
    */
    v3sSelectionService.onSelectionChanged($rootScope, function (selection, type) {
        if (type == "lexikon" && selection && selection.indexOf("LEX") == 0) {
            selection = selection.substring(3);
        }

        postResult("selection", { selection: selection, type: type });
    });

    /**
    * ...
    * @function onStateChangeSuccess
    * @memberOf v3sWbtPlayerApp:annotation.service_v3sAnnotationService
    * @param {Object} toState - ...
    */
    $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
        location();
    });

    return {}
}]);
